<template>
    <c-modal
            v-model="model"
            centered size="md"
            title="Clear confirmation"
            :tag="false"
            @hide="hide"
            @submit="submit">
        <div style="font-size: 1.1rem;">
            Do you want to clear all the tab information you entered?
        </div>
        <template #actions="{ submit, hide }">
        <b-row class="flex-grow-1">
          <b-col cols="6">
            <b-btn variant="warning" block class="text-nowrap credit-modal-btn" @click="submit">
              Clear Tab
            </b-btn>
          </b-col>
          <b-col cols="6">
            <b-btn variant="danger" block class="text-nowrap credit-modal-btn cancel-btn-cmodal" @click="hide">
              Cancel
            </b-btn>
          </b-col>
        </b-row>
      </template>
    </c-modal>
</template>

<script>
    import CModal from "../../shared/Cmodal";
    export default {
        name: "attentionRemoveItems",
        components: {CModal},
        props: {
            value: {required: true, type: Boolean, default: false}
        },
        computed: {
            model: {
                get () {
                    return this.value
                },
                set (val) {
                    this.$emit('input', val)
                }
            }
        },
        methods: {
            hide () {
                this.model = false
            },
            submit () {
                //location.reload()
                this.$emit('clear')
            }
        }
    }
</script>

<style scoped>

.credit-modal-btn {
  font-size: 1.3rem;
  height: 3rem;
}
</style>
